import COM from './Blocks'

export default COM
